import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';
import { CookieService } from 'ngx-cookie';

/**
 * Guard to prevent access to customer access page when activeCustomer already exists
 * If user has an orgname/activeCustomer, redirect them directly to their dashboard
 */
@Injectable({
  providedIn: 'root'
})
export class SiCustomerAccessRedirectGuard implements CanActivate {
  constructor(
    private siAuthenticationService: SiAuthenticationService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  /**
   * Checks if user should be allowed to access the customer access page
   * @param route - Activated route snapshot
   * @param state - Router state snapshot
   * @returns boolean - true if access allowed, false if should redirect
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    console.log('[CUSTOMER-ACCESS-GUARD] ========== GUARD ACTIVATED ==========');
    console.log('[CUSTOMER-ACCESS-GUARD] Checking access to customer access page');
    console.log('[CUSTOMER-ACCESS-GUARD] Route:', state.url);
    
    let activeCustomer = this.siAuthenticationService.getActiveCustomer();
    console.log('[CUSTOMER-ACCESS-GUARD] Active Customer from service:', activeCustomer);
    
    // Fallback: Check cookies and localStorage if activeCustomer is not set
    if (!activeCustomer) {
      // Check multiple storage locations
      const cookieActiveCustomer = this.cookieService.get('activeCustomer');
      const cookieOrgname = this.cookieService.get('orgname');
      const localStorageCustomer = localStorage.getItem('activeCustomer');
      const sessionStorageCustomer = sessionStorage.getItem('activeCustomer');
      
      console.log('[CUSTOMER-ACCESS-GUARD] Storage check:');
      console.log('  - Cookie activeCustomer:', cookieActiveCustomer);
      console.log('  - Cookie orgname:', cookieOrgname);
      console.log('  - localStorage:', localStorageCustomer);
      console.log('  - sessionStorage:', sessionStorageCustomer);
      
      activeCustomer = cookieActiveCustomer || 
                      cookieOrgname ||
                      localStorageCustomer ||
                      sessionStorageCustomer;
      
      console.log('[CUSTOMER-ACCESS-GUARD] Active Customer from storage fallback:', activeCustomer);
      
      // If found in storage, set it in the authentication service
      if (activeCustomer) {
        console.log('[CUSTOMER-ACCESS-GUARD] Setting activeCustomer from storage:', activeCustomer);
        this.siAuthenticationService.setActiveCustomer(activeCustomer);
        
        // Small delay to ensure service is updated
        setTimeout(() => {
          console.log('[CUSTOMER-ACCESS-GUARD] Verified activeCustomer set:', 
                     this.siAuthenticationService.getActiveCustomer());
        }, 100);
      }
    }
    
    if (activeCustomer) {
      // If activeCustomer exists (orgname is present), redirect to dashboard
      console.log('[CUSTOMER-ACCESS-GUARD] ✅ Active customer exists, redirecting to dashboard:', activeCustomer);
      
      const unformattedName = this.siAuthenticationService.getUnformattedCustomerName(activeCustomer);
      console.log('[CUSTOMER-ACCESS-GUARD] Unformatted customer name:', unformattedName);
      
      this.router.navigate([unformattedName]);
      return false; // Prevent access to customer access page
    }
    
    // No active customer, allow access to customer selection page
    console.log('[CUSTOMER-ACCESS-GUARD] ❌ No active customer found, allowing access to customer selection page');
    console.log('[CUSTOMER-ACCESS-GUARD] ========== GUARD COMPLETE ==========');
    return true;
  }
}
